import dataLayer from 'assets/core/js/module/data-layer'

export const pushDataLayerFilterEvent = (filter: HTMLInputElement): void => {
  const filterValue = filter.getAttribute('data-filter-datalayer-value') ?? ''
  const parentFilterBlock = filter.closest('.filter__block[data-filter-datalayer-section]')
  const filterSection = parentFilterBlock?.getAttribute('data-filter-datalayer-section') ?? ''

  dataLayer.pushInLayer(window.coreGtmId, {
    event: dataLayer.events.FILTER,
    page_category: dataLayer.getPageCategory(window.coreGtmId) ?? '',
    filter_value: filterValue,
    filter_section: filterSection,
  })
}

export const pushDataLayerBudgetEvent = (value: string): void => {
  const budgetSection = document.querySelector('.filter__block[data-filter="budgets"]')
  const filterSection = budgetSection?.getAttribute('data-filter-datalayer-section') ?? ''

  dataLayer.pushInLayer(window.coreGtmId, {
    event: dataLayer.events.FILTER,
    page_category: dataLayer.getPageCategory(window.coreGtmId) ?? '',
    filter_value: value.replace(':', '-'),
    filter_section: filterSection,
  })
}

export default {}
